export default __webpack_public_path__ + "static/media/burger.c2fd1fcd.svg";